import styled from 'styled-components'

export const NewSiteFooterWrapper = styled.div`
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  height: 72px;
  background: rgb(248,248,248);
`

export const NewSiteFooterButtonWrapper = styled.div`
  display: flex;
  gap: 16px;

  > button {
    margin: 0;
  }
`

export const NewSiteFooterCenterPart = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-width: 0;
`

export const NewSiteFooterRightPart = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-width: 0;
`

export const CompleteListTabField = styled.li`
  font-weight: 400;
  line-height: 16px;
  font-size: 14px;
  text-decoration: none;
  color: #202020;
  margin-right: 32px;
`

export const CompleteListContainer = styled.div`
  display: flex;
`

export const ValidationProposalModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;

  button:last-child {
    margin-left: 16px;
  }
`

export const ValidationProposalModalText = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`

export const FooterButtonDivider = styled.div`
  height: 24px;
  width: 1px;
  background-color: rgba(32, 32, 32, 0.1);
  margin: 0 32px;
`
export const StyleSiteName = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`

export const ValidationProposalModalFooterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button:last-child {
    margin-left: 16px;
  }
`
